import { DDL, Option } from 'types/general.types';

export const toCountryOptions: (countries?: DDL) => Option[] = (countries) => {
  if (!countries) {
    return [];
  }
  return Object.values(countries)
    .map((el) => ({
      title: el.name,
      value: el.key,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));
};
